"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeNodePlaceholder = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = () => ({
    root: {},
    lines: {
        position: 'absolute',
        zIndex: 0,
        borderBottom: `2px solid ${lib_palette_1.default.LavendarGrey.main}`,
        width: 50,
        height: 49,
        top: -24,
    },
    expander: {
        position: 'relative',
        width: 36,
        height: 48,
    },
    text: {},
});
exports.QuestionTreeNodePlaceholder = react_1.default.memo(() => {
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (react_1.default.createElement("div", { className: myCss.root + ' noDnD' },
        react_1.default.createElement(Horizontal_1.default, { centered: true },
            react_1.default.createElement(Pane_1.default, { classes: { root: myCss.expander } },
                react_1.default.createElement("div", { className: myCss.lines })),
            react_1.default.createElement(Pane_1.default, { grow: true, padding: true, classes: { root: myCss.text } },
                react_1.default.createElement(Text_1.default, null, "Drag a question here")))));
});
exports.default = exports.QuestionTreeNodePlaceholder;
